import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Promo } from 'landings/promo';
import { RemoteProps } from './widgets-types';

export const PromoRemote: React.FC<RemoteProps> = ({ router, store }) => (
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Promo />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
